import { useState, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useUpdateReferralCodeMandatory } from 'api';

export const useReferralCodeModal = ({
  evaluatorId,
  savedReferralCodeMandatory,
  isFetchingEvaluatorLink,
}: {
  evaluatorId: string;
  savedReferralCodeMandatory?: boolean;
  isFetchingEvaluatorLink?: boolean;
}) => {
  const queryClient = useQueryClient();
  const [isReferralCodeModalOpen, setIsReferralCodeModalOpen] = useState(false);

  const { mutate, isPending } = useUpdateReferralCodeMandatory(queryClient);

  const isReferralCodeToggleDisabled = isPending || isFetchingEvaluatorLink;

  const updatedReferralCodeMandatory = useCallback(
    (referralCode: boolean) => {
      if (referralCode !== savedReferralCodeMandatory) {
        mutate({
          evaluatorId,
          isReferralCodeMandatory: referralCode,
        });
      }
    },
    [evaluatorId, mutate, savedReferralCodeMandatory],
  );

  return {
    isReferralCodeToggleDisabled,
    isReferralCodeMandatory: savedReferralCodeMandatory ?? false,
    isReferralCodeModalOpen,
    updatedReferralCodeMandatory,
    setIsReferralCodeModalOpen,
  };
};
